/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at April 05 2024
 **/

import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";
import { useGroupCall } from "@/frameworks/core/API";
import { Properties } from "@/frameworks/libraries/properties";
import { JotaiStore } from "@/frameworks/libraries/commons";
import PhoneCallAtoms from "./PhoneCallAtoms";
import { Configure } from "@/frameworks/libraries/utilities";

export default function usePhoneRecent() {
	const callList = useAtomValue(PhoneCallAtoms.CallList, { store: JotaiStore });
	const { data, refetch } = useQuery({
		queryKey: ["recentList"],
		queryFn: async () => (Configure.is_authenticated && (await groupCallAPI.recent.execute())) || null,
		refetchOnMount: false,
		refetchOnWindowFocus: false
	});

	const groupCallAPI = useGroupCall({
		onSuccess(name) {
			switch (name) {
				case "groupCall:remove":
				case "groupCall:removeAll": {
					refetch();
					break;
				}
			}
		}
	});

	useEffect(() => {
		refetch();
	}, [Object.values(callList).length]);

	const callLog = {
		get: (userID: string) => groupCallAPI.detail.execute({ targetUserId: userID }),
		getAll: (options: WebServices.GroupCall.Recent.Request = {}) => groupCallAPI.recent.execute(options),
		delete: (callID: string) => groupCallAPI.delete.execute({ callId: callID }),
		deleteAll: () => groupCallAPI.deleteAll.execute()
	};

	return {
		...callLog,
		list: data?.data
	};
}
